import { toastController } from "@ionic/vue";
import { t } from "@/plugins/vue-i18n";

import { ToastOption } from "@/types/functions";
import { ION_TOAST_POSITION, ION_VARIANT } from "@/types/enum/ionicEnum";
import { PartiallyRequired } from "@/types/helper";
import { isApp } from "./enviroment";

const popToast = async (params: ToastOption, cypressId?: string): Promise<HTMLIonToastElement> => {
    const { color, duration, position, cssClass } = params

    const defaultParam = {
        ...params,
        duration: duration ?? 3000,
        color: color ?? ION_VARIANT.CORAL,
        ...(isApp() ? {
            position: position ?? ION_TOAST_POSITION.BOTTOM,
            cssClass: ['custom-toast', cssClass ? (typeof cssClass === 'string' ? cssClass : cssClass.join(' ')) : '']
        } : {
            position: position ?? ION_TOAST_POSITION.TOP,
            cssClass: ['custom-toast-web', 'toast-offset-web-app']
        })
    }

    const toast = await toastController.create(defaultParam)

    toast.dataset.cy = cypressId

    await toast.present()

    return toast
}

const replaceToast = async (params: PartiallyRequired<ToastOption, 'id'>, cypressId?: string, noDismiss = false): Promise<HTMLIonToastElement> => {
    const { id } = params

    const toast = await toastController.getTop()
    if (toast?.id !== id) {
        if (!noDismiss) await toast?.dismiss()
        else if (toast) return toast
    }
    if (toast?.id === id) return toast;
    return await popToast(params, cypressId)
}

// TODO: Move to types folder
interface FeedbackMessage {
    type: string;
    target?: string;
    id: string;
    plural?: number;
    pluralTarget?: number;
}

const interactionFeedbackToast = async (success: boolean, message: FeedbackMessage, toastOptions?: ToastOption, noDismiss = false): Promise<HTMLIonToastElement> => {
    if (!success) {
        return await replaceToast({
            message: t(
                `error.${message.type}`,
                //* New vueI18n requires t for this translation but typescript function has not the correct typing yet
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                message.target ? { target: t(`target.${message.target}`, message.pluralTarget) } : undefined,
                message.plural
            ),
            id: `${message.id}-error`,
            ...toastOptions
        }, `${message.id}-error`, noDismiss)
    }

    return await replaceToast({
        message: t(
            `success.${message.type}`,
            //* New vueI18n requires t for this translation but typescript function has not the correct typing yet
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            message.target ? { target: t(`target.${message.target}`, message.pluralTarget) } : undefined,
            message.plural
        ),
        id: `${message.id}-success`,
        ...toastOptions
    }, `${message.id}-error`, noDismiss)
}

export {
    popToast,
    replaceToast,
    interactionFeedbackToast
}
